import * as React from "react";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";
import { UitkText } from "uitk-react-text";
import { decorateEditorialHtml } from "../../../../ContentUtilities";

export const CitifaqHeader = (props: { items: EditorialModel[] }) => {
  const { items } = props;
  if (items.length !== 1) {
    return null;
  }

  return (
    <div>
      <UitkText align="center" size={600} weight="bold">
        <div
          className="all-b-padding-six all-t-padding-twelve"
          dangerouslySetInnerHTML={decorateEditorialHtml(items[0].text)}
        />
      </UitkText>
    </div>
  );
};

export default CitifaqHeader;
